export const fontList = [
  'Arimo',
  'Brygada 1918',
  'Comfortaa',
  'Flama',
  'Helvetica Neue',
  'Heebo',
  'Inconsolata',
  'Lobster',
  'Merriweather',
  'Montserrat',
  'Outfit',
  'Oswald',
  'Overpass',
  'Philosopher',
  'Poppins',
  'Raleway',
  'Sans-Serif',
  'Syne',
  'Tomorrow',
  'Ultra',
  'Inter'
] as const;
